import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

const Correct = ({ motion, mobile, nextQuestion, final, finishQuiz, text }) => {
    return (
        <Fragment>
            <motion.div
                animate={{ scale: [1.2, 1, 1.1, 1] }}
                transition={{ duration: .6 }}
            >
                <div className="question question--correct">
                    <div className="question__header">
                        <motion.span
                            className="icon icon-correct"
                            animate={{ scale: [0, 1] }}
                            transition={{ duration: .2 }}
                        />
                        <FormattedMessage id="correct.title" defaultMessage="Good Job!">
                            {
                                label => (
                                    <p className="title">{label}</p>
                                )
                            }
                        </FormattedMessage>
                    </div>
                    <div className="question__content">
                        <p>{text}</p>
                    </div>
                </div>
            </motion.div>
            {
                !mobile &&
                <div className="question__footer">
                    {
                        !final ?
                        <FormattedMessage id="correct.button.next" defaultMessage="Next Question">
                            {
                                label => (
                                <button onClick={nextQuestion} className="btn btn--primary btn--teal" type="button"><span className="label">{label}</span></button>
                                )
                            }
                        </FormattedMessage>
                        :
                        <FormattedMessage id="correct.button.finish" defaultMessage="Finish Quiz">
                            {
                                label => (
                                    <button onClick={finishQuiz} className="btn btn--primary btn--teal" type="button"><span className="label">{label}</span></button>
                                )
                            }
                        </FormattedMessage>
                    }
                </div>
            }
        </Fragment>
    )
}

Correct.propTypes = {

}

export default Correct
